// import React, { useEffect, useState } from "react";
// import { IconPlaneTilt } from "@tabler/icons-react";
// import { useDispatch, useSelector } from "react-redux";
// import { getStudentDetails } from "../../services/admin.services";
// import { setUserDetails } from "../../state/reducers/userSlice";
// import { useLocation } from "react-router-dom";

// const StatusComponent = () => {
//   const userId = useSelector((state) => state.user.user_id);
//   const userDetails = useSelector((state) => state.user.userDetails);
//   "userDetails", userDetails);

//   const [id, setId] = useState(null);
//   const [loading, setLoading] = useState(true); // Loading state
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);
//   // Fetch student details when `id` changes
//   const getStudent = async () => {
//     if (id) {
//       setLoading(true); // Show loading spinner
//       try {
//         const res = await getStudentDetails(id);
//         dispatch(setUserDetails(res.data));
//       } catch (error) {
//         console.error("Error fetching student details:", error);
//       } finally {
//         setLoading(false); // Hide loading spinner
//       }
//     }
//   };

//   // const calculateProgress = () => {
//   //   const totalFields = 5; // Total number of fields to track
//   //   let completedFields = 0;

//   //   // First 50% progress (Documents Upload)
//   //   let docUploads = 0;
//   //   if (userDetails?.resume_cv_url) docUploads++;
//   //   if (userDetails?.shortlisting) docUploads++;
//   //   if (userDetails?.sop_url || userDetails?.lor_url?.length) docUploads++;
//   //   if (userDetails?.university_sop_url || userDetails?.university_essay_url)
//   //     docUploads++;
//   //   if (userDetails?.final_doc_urls?.length > 0) docUploads++; // Added extra field

//   //   let firstProgress = (docUploads / 3) * 50; // Only first 3 fields count towards first bar

//   //   // Remaining 50% progress (Application Process & Visa)
//   //   let appProgress = 0;
//   //   if (userDetails?.is_show_table_to_student) appProgress++; // Application Process sent
//   //   if (
//   //     userDetails?.is_finalized_excel?.some(
//   //       (item) =>
//   //         item.status === "Submitted" ||
//   //         item.status === "Accepted" ||
//   //         item.status === "Finalized"
//   //     )
//   //   )
//   //     appProgress++; // Application Submitted
//   //   if (
//   //     userDetails?.is_finalized_excel?.some(
//   //       (item) => item.status === "Accepted" || item.status === "Finalized"
//   //     )
//   //   )
//   //     appProgress++; // Decision Received
//   //   if (
//   //     userDetails?.is_finalized_excel?.some(
//   //       (item) => item.status === "Finalized"
//   //     )
//   //   )
//   //     appProgress++; // University Finalized
//   //   if (userDetails?.visa_process_completed) appProgress++; // Visa Process Completed

//   //   let secondProgress = (appProgress / 2) * 50; // Last 2 fields count towards second bar

//   //   return {
//   //     firstProgress: Math.round(firstProgress),
//   //     secondProgress: Math.round(secondProgress),
//   //   };
//   // };
//   // Replace your current calculateProgress function with this one
//   const calculateProgress = () => {
//     // First Progress Bar: Documents Upload
//     let docUploads = 0;
//     const totalDocUploads = 5;

//     if (userDetails?.resume_cv_url) docUploads++;
//     if (userDetails?.shortlisting) docUploads++;
//     if (userDetails?.sop_url || userDetails?.lor_url?.length) docUploads++;
//     if (userDetails?.university_sop_url || userDetails?.university_essay_url)
//       docUploads++;
//     if (userDetails?.final_doc_urls?.length > 0) docUploads++;

//     // Calculate full percentage (not limited to 50%)
//     let firstProgress = (docUploads / totalDocUploads) * 100;

//     // Second Progress Bar: University Application + Visa Process
//     let appProgress = 0;
//     const totalAppProgress = 5;

//     if (userDetails?.is_show_table_to_student) appProgress++;
//     if (
//       userDetails?.is_finalized_excel?.some(
//         (item) =>
//           item.status === "Submitted" ||
//           item.status === "Accepted" ||
//           item.status === "Finalized"
//       )
//     )
//       appProgress++;

//     if (
//       userDetails?.is_finalized_excel?.some(
//         (item) => item.status === "Accepted" || item.status === "Finalized"
//       )
//     )
//       appProgress++;

//     if (
//       userDetails?.is_finalized_excel?.some(
//         (item) => item.status === "Finalized"
//       )
//     )
//       appProgress++;

//     if (userDetails?.visa_process_completed) appProgress++;

//     // Calculate full percentage (not limited to 50%)
//     let secondProgress = (appProgress / totalAppProgress) * 100;

//     return {
//       firstProgress: Math.round(firstProgress),
//       secondProgress: Math.round(secondProgress),
//     };
//   };

//   // const calculateProgress = () => {
//   //   const totalFields = 5; // Total number of fields to track
//   //   let completedFields = 0;

//   //   if (userDetails?.resume_cv_url) completedFields++;
//   //   if (userDetails?.shortlisting) completedFields++;
//   //   if (userDetails?.sop_url || userDetails?.lor_url?.length) completedFields++;
//   //   if (userDetails?.university_sop_url || userDetails?.university_essay_url)
//   //     completedFields++;
//   //   if (userDetails?.final_doc_urls?.SOP?.length) completedFields++;

//   //   // Calculate actual progress percentage
//   //   let actualProgress = (completedFields / totalFields) * 50; // Only use remaining 50%

//   //   return Math.round(50 + actualProgress); // Always start from 50%
//   // };

//   // Set `id` based on location or Redux state
//   useEffect(() => {
//     if (location.pathname.includes("admin")) {
//       const user_id = location.pathname.split("/").pop(); // Get ID from URL
//       setId(user_id);
//     } else {
//       setId(userId); // Use Redux userId
//     }
//   }, [location.pathname, userId]);

//   // Fetch student data when `id` is updated
//   useEffect(() => {
//     getStudent();
//   }, [id]);

//   // Calculate progress based on completed fields
//   // const calculateProgress = () => {
//   //   const totalFields = 5; // Total number of fields to track
//   //   let completedFields = 0;

//   //   if (userDetails?.resume_cv_url) completedFields++;
//   //   if (userDetails?.shortlisting) completedFields++;
//   //   if (userDetails?.sop_url || userDetails?.lor_url?.length) completedFields++;
//   //   if (userDetails?.university_sop_url || userDetails?.university_essay_url)
//   //     completedFields++;
//   //   if (userDetails?.final_doc_urls?.SOP?.length) completedFields++;

//   //   return Math.round((completedFields / totalFields) * 100);
//   // };

//   // Show loading spinner until data is fetched
//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         Loading...
//       </div>
//     );
//   }

//   const { firstProgress, secondProgress } = calculateProgress();

//   return (
//     <>
//       {/* <div
//         className={`flex-1 bg-pink-500 ${
//           isSideBarOpen ? "ml-80" : "ml-0 md:ml-20"
//         } min-h-screen`}
//       > */}
//       <div
//         className={`${
//           location.pathname.includes("admin") ? "ml-80" : "ml-0 md:ml-20"
//         } min-h-screen`}
//       >
//         <div className="flex justify-center h-11/12 p-4">
//           <div className="w-full justify-center lg:w-full xl:w-9/12 2xl:w-8/12 p-36 flex  items-center rounded-md transition-all duration-500 ease-in-out transform">
//             <div className="relative flex flex-col md:flex-row flex-wrap justify-between w-full bg-gray-100 p-2 md:p-4 lg:p-8 rounded-lg shadow-lg transition-all duration-500 ease-in-out transform">
//               <h2 className="hidden text-center md:block text-2xl font-semibold mb-6 w-full transition-all duration-300 ease-in-out">
//                 Application Completion Progress
//               </h2>
//               <h2 className="block md:hidden text-2xl font-semibold mb-6 w-full text-center transition-all duration-300 ease-in-out">
//                 Application Status
//               </h2>

//               {/* Documents Upload Section */}
//               <div className="flex flex-col items-start md:items-center flex-1 transition-transform duration-500 ease-in-out transform">
//                 <div className="flex">
//                   <div className="flex items-center mb-6 mt-4 md:mt-0">
//                     <div className="bg-green-100 p-6 rounded-full transition-transform duration-300 ease-in-out">
//                       <img src="/icons/Upload.png" alt="Upload" />
//                     </div>
//                     <h3 className="ml-2 flex md:hidden text-lg font-medium transition-all duration-300 ease-in-out">
//                       Documents Uploads
//                     </h3>
//                   </div>
//                 </div>
//                 <div className="flex flex-col items-center px-6 md:border-r border-gray-300 md:w-full h-full">
//                   <h3 className="h-14 hidden md:flex mb-4 text-lg text-center font-medium transition-all duration-300 ease-in-out">
//                     Your Documents Uploads
//                   </h3>
//                   <ul className="pl-14 md:pl-0 w-full list-none space-y-4 md:space-y-2 text-gray-700">
//                     <li className="flex items-start">
//                       <span
//                         className={`hidden md:flex mr-2 ${
//                           userDetails?.resume_cv_url
//                             ? "text-green-500"
//                             : "text-gray-500"
//                         }`}
//                       >
//                         {userDetails?.resume_cv_url ? "✔" : "✖"}
//                       </span>
//                       CV Upload
//                     </li>
//                     <li className="flex items-start">
//                       <span
//                         className={`hidden md:flex mr-2 ${
//                           userDetails?.shortlisting
//                             ? "text-green-500"
//                             : "text-gray-500"
//                         }`}
//                       >
//                         {userDetails?.shortlisting ? "✔" : "✖"}
//                       </span>
//                       Shortlisted Universities
//                     </li>
//                     <li className="flex items-start">
//                       <span
//                         className={`hidden md:flex mr-2 ${
//                           userDetails?.sop_url || userDetails?.lor_url?.length
//                             ? "text-green-500"
//                             : "text-gray-500"
//                         }`}
//                       >
//                         {userDetails?.sop_url || userDetails?.lor_url?.length
//                           ? "✔"
//                           : "✖"}
//                       </span>
//                       SOP/LORs
//                     </li>
//                     <li className="flex items-start">
//                       <span
//                         className={`hidden md:flex mr-2 ${
//                           userDetails?.university_sop_url ||
//                           userDetails?.university_essay_url
//                             ? "text-green-500"
//                             : "text-gray-500"
//                         }`}
//                       >
//                         {userDetails?.university_sop_url ||
//                         userDetails?.university_essay_url
//                           ? "✔"
//                           : "✖"}
//                       </span>
//                       Essays/University Specific SOPs
//                     </li>
//                     <li className="flex items-start">
//                       <span
//                         className={`hidden md:flex mr-2 ${
//                           userDetails?.final_doc_urls > 0
//                             ? "text-green-500"
//                             : "text-gray-500"
//                         }`}
//                       >
//                         {userDetails?.final_doc_urls ||
//                         userDetails?.final_doc_urls
//                           ? "✔"
//                           : "✖"}
//                         {/* {userDetails?.final_doc_urls > 0 ? "✔" : "✖"} */}
//                       </span>
//                       Final Documents Upload
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//               {/* <div className="mt-2 md:mt-0 absolute bg-gray-300 rounded-full mb-8 w-3 h-52 md:h-3 md:w-1/5 top-32 md:top-1/4 lg:top-28 left-6 md:left-1/4 transition-all duration-500 ease-in-out">
//                 <div
//                   className="bg-indigo-500 rounded-full transition-all duration-500 ease-in-out"
//                   style={{ height: `${calculateProgress()}%`, width: "100%" }} // Dynamic height
//                 ></div>
//               </div> */}
//               <div className="absolute bg-gray-300 rounded-full mb-8 w-3 h-52 md:h-3 md:w-1/5 top-32 md:top-1/4 lg:top-28 left-6 md:left-1/4 transition-all duration-500 ease-in-out">
//                 <div
//                   className="bg-indigo-500 h-full md:h-3 rounded-full transition-all duration-500 ease-in-out"
//                   style={{ width: `${firstProgress}%` }}
//                 ></div>
//               </div>
//               {/* University Application Process */}
//               <div className="flex flex-col items-start md:items-center flex-1 transition-transform duration-500 ease-in-out transform">
//                 <div className="flex">
//                   <div className="flex items-center mb-6 mt-4 md:mt-0">
//                     <div className="bg-green-100 p-3 rounded-full transition-transform duration-300 ease-in-out">
//                       <img src="/icons/University.png" alt="University" />
//                     </div>
//                     <h3 className="ml-2 flex md:hidden text-lg font-medium transition-all duration-300 ease-in-out">
//                       University Application Process
//                     </h3>
//                   </div>
//                 </div>
//                 <div className="flex flex-col items-center md:border-r border-gray-300 md:w-full h-full">
//                   <h3 className="h-14 hidden md:flex mb-4 text-lg text-center font-medium transition-all duration-300 ease-in-out">
//                     University Application Process
//                   </h3>
//                   <ul className="pl-14 md:pl-0 w-full list-none space-y-4 md:space-y-2 text-gray-700">
//                     <li className="flex items-start">
//                       {/* <span className="hidden md:flex text-green-500 mr-2">
//                         ✔
//                       </span> */}
//                       {userDetails?.is_show_table_to_student ? "✔" : "✖"}
//                       Application Process sent
//                     </li>
//                     <li className="flex items-start">
//                       {userDetails?.is_finalized_excel?.some(
//                         (item) =>
//                           item.status === "Submitted" ||
//                           item.status === "Accepted" ||
//                           item.status === "Finalized"
//                       )
//                         ? "✔"
//                         : "✖"}
//                       Applications Submitted
//                     </li>

//                     <li className="flex items-start">
//                       {/* <span className="hidden md:flex text-gray-500 mr-2">
//                         ✖
//                       </span> */}
//                       {userDetails?.is_finalized_excel?.some(
//                         (item) =>
//                           item.status === "Accepted" ||
//                           item.status === "Finalized"
//                       )
//                         ? "✔"
//                         : "✖"}
//                       Decision Received
//                     </li>
//                     <li className="flex items-start">
//                       {/* <span className="hidden md:flex text-gray-500 mr-2">
//                         ✖
//                       </span> */}
//                       {userDetails?.is_finalized_excel?.some(
//                         (item) => item.status === "Finalized"
//                       )
//                         ? "✔"
//                         : "✖"}
//                       University Finalized
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//               <div className="absolute bg-gray-300 rounded-full mb-8 w-3 md:w-1/5 h-1/4 md:h-3 top-[400px] left-6 md:left-auto md:top-1/4 lg:top-28 md:right-1/4 transition-all duration-500 ease-in-out">
//                 <div
//                   className="bg-indigo-500 md:h-3 rounded-full transition-all duration-500 ease-in-out"
//                   style={{ width: `${secondProgress}%` }}
//                 ></div>
//               </div>
//               {/* Visa Process */}
//               <div className="flex flex-col items-start md:items-center flex-1 transition-transform duration-500 ease-in-out transform">
//                 <div className="flex items-center mb-6 mt-4 md:mt-0">
//                   <div className="bg-green-500 p-3 rounded-full transition-transform duration-300 ease-in-out">
//                     <IconPlaneTilt stroke={0} fill="white" />
//                   </div>
//                   <h3 className="ml-2 flex md:hidden text-lg font-medium transition-all duration-300 ease-in-out">
//                     Visa Process
//                   </h3>
//                 </div>
//                 <div className="flex flex-col items-center md:w-full h-full">
//                   <h3 className="h-14 hidden md:flex mb-4 text-lg font-medium transition-all duration-300 ease-in-out">
//                     Visa Process
//                   </h3>
//                   <ul className="pl-14 md:pl-0 w-full list-none space-y-2 text-gray-700">
//                     <li className="flex items-start">
//                       {/* <span className="hidden md:flex text-green-500 mr-2">
//                         ✔
//                       </span> */}
//                       {userDetails.visa_process_completed ? "✔" : "✖"}
//                       Visa Process Completed
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* </div> */}
//     </>
//   );
// };

// export default StatusComponent;

import React, { useEffect, useState } from "react";
import { IconPlaneTilt } from "@tabler/icons-react";
import { useDispatch, useSelector } from "react-redux";
import { getStudentDetails } from "../../services/admin.services";
import { setUserDetails } from "../../state/reducers/userSlice";
import { useLocation } from "react-router-dom";

const StatusComponent = () => {
  const userId = useSelector((state) => state.user.user_id);
  const userDetails = useSelector((state) => state.user.userDetails);
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const location = useLocation();
  const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);

  // Fetch student details
  const getStudent = async () => {
    if (id) {
      setLoading(true);
      try {
        const res = await getStudentDetails(id);
        dispatch(setUserDetails(res.data));
      } catch (error) {
        console.error("Error fetching student details:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  // Calculate progress
  const calculateProgress = () => {
    // Documents Upload progress
    let docUploads = 0;
    const totalDocUploads = 5;

    if (userDetails?.resume_cv_url) docUploads++;
    if (userDetails?.shortlisting) docUploads++;
    if (userDetails?.sop_url || userDetails?.lor_url?.length) docUploads++;
    if (userDetails?.university_sop_url || userDetails?.university_essay_url)
      docUploads++;
    if (userDetails?.final_doc_urls || userDetails?.final_doc_urls?.length > 0)
      docUploads++;

    const firstProgress = (docUploads / totalDocUploads) * 100;

    // University Application progress
    let appProgress = 0;
    const totalAppProgress = 5;

    if (userDetails?.is_show_table_to_student) appProgress++;
    if (
      userDetails?.is_finalized_excel?.some(
        (item) =>
          item.status === "Submitted" ||
          item.status === "Accepted" ||
          item.status === "Finalized"
      )
    )
      appProgress++;

    if (
      userDetails?.is_finalized_excel?.some(
        (item) => item.status === "Accepted" || item.status === "Finalized"
      )
    )
      appProgress++;

    if (
      userDetails?.is_finalized_excel?.some(
        (item) => item.status === "Finalized"
      )
    )
      appProgress++;

    if (userDetails?.visa_process_completed) appProgress++;

    const secondProgress = (appProgress / totalAppProgress) * 100;

    return {
      firstProgress: Math.round(firstProgress),
      secondProgress: Math.round(secondProgress),
    };
  };

  // Set ID based on location
  useEffect(() => {
    if (location.pathname.includes("admin")) {
      const user_id = location.pathname.split("/").pop();
      setId(user_id);
    } else {
      setId(userId);
    }
  }, [location.pathname, userId]);

  // Fetch data when ID changes
  useEffect(() => {
    getStudent();
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading...
      </div>
    );
  }

  const { firstProgress, secondProgress } = calculateProgress();

  return (
    <div
      className={`w-full ${
        location.pathname.includes("admin")
          ? isSideBarOpen
            ? "lg:pl-80"
            : "lg:pl-20"
          : "md:pl-20"
      } min-h-screen transition-all duration-300 overflow-hidden`}
    >
      <div className="w-full px-4 py-6 flex justify-center">
        <div className="w-full max-w-6xl bg-gray-100 rounded-lg shadow-lg p-4 sm:p-6">
          <h2 className="text-xl lg:text-2xl font-semibold text-center mb-6">
            Application Completion Progress
          </h2>

          {/* Main content container */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative">
            {/* Document Upload Section */}
            <div className="bg-white p-4 rounded-lg shadow">
              <div className="flex items-center mb-3">
                <div className="bg-green-100 p-3 rounded-full mr-3 flex-shrink-0">
                  <img
                    src="/icons/Upload.png"
                    alt="Upload"
                    className="w-6 h-6"
                  />
                </div>
                <h3 className="text-lg font-medium">Document Uploads</h3>
              </div>

              {/* Progress bar */}
              <div className="w-full h-2 bg-gray-200 rounded-full mb-4">
                <div
                  className="h-2 bg-indigo-500 rounded-full"
                  style={{ width: `${firstProgress}%` }}
                ></div>
              </div>

              {/* Items */}
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span
                    className={`mr-2 ${
                      userDetails?.resume_cv_url
                        ? "text-green-500"
                        : "text-gray-500"
                    }`}
                  >
                    {userDetails?.resume_cv_url ? "✓" : "✗"}
                  </span>
                  <span>CV Upload</span>
                </li>
                <li className="flex items-start">
                  <span
                    className={`mr-2 ${
                      userDetails?.shortlisting
                        ? "text-green-500"
                        : "text-gray-500"
                    }`}
                  >
                    {userDetails?.shortlisting ? "✓" : "✗"}
                  </span>
                  <span>Shortlisted Universities</span>
                </li>
                <li className="flex items-start">
                  <span
                    className={`mr-2 ${
                      userDetails?.sop_url || userDetails?.lor_url?.length
                        ? "text-green-500"
                        : "text-gray-500"
                    }`}
                  >
                    {userDetails?.sop_url || userDetails?.lor_url?.length
                      ? "✓"
                      : "✗"}
                  </span>
                  <span>SOP/LORs</span>
                </li>
                <li className="flex items-start">
                  <span
                    className={`mr-2 ${
                      userDetails?.university_sop_url ||
                      userDetails?.university_essay_url
                        ? "text-green-500"
                        : "text-gray-500"
                    }`}
                  >
                    {userDetails?.university_sop_url ||
                    userDetails?.university_essay_url
                      ? "✓"
                      : "✗"}
                  </span>
                  <span>Essays/University SOPs</span>
                </li>
                <li className="flex items-start">
                  <span
                    className={`mr-2 ${
                      userDetails?.final_doc_urls ||
                      userDetails?.final_doc_urls?.length > 0
                        ? // userDetails?.final_doc_urls?.length > 0
                          "text-green-500"
                        : "text-gray-500"
                    }`}
                  >
                    {userDetails?.final_doc_urls ||
                    userDetails?.final_doc_urls?.length
                      ? "✓"
                      : "✗"}
                    {/* {userDetails?.final_doc_urls?.length > 0 ? "✓" : "✗"} */}
                  </span>
                  <span>Final Documents Upload</span>
                </li>
              </ul>
            </div>

            {/* University Application Section */}
            <div className="bg-white p-4 rounded-lg shadow">
              <div className="flex items-center mb-3">
                <div className="bg-green-100 p-3 rounded-full mr-3 flex-shrink-0">
                  <img
                    src="/icons/University.png"
                    alt="University"
                    className="w-6 h-6"
                  />
                </div>
                <h3 className="text-lg font-medium">University Application</h3>
              </div>

              {/* Progress bar */}
              <div className="w-full h-2 bg-gray-200 rounded-full mb-4">
                <div
                  className="h-2 bg-indigo-500 rounded-full"
                  style={{ width: `${secondProgress}%` }}
                ></div>
              </div>

              {/* Items */}
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span
                    className={`mr-2 ${
                      userDetails?.is_show_table_to_student
                        ? "text-green-500"
                        : "text-gray-500"
                    }`}
                  >
                    {userDetails?.is_show_table_to_student ? "✓" : "✗"}
                  </span>
                  <span>Application Process sent</span>
                </li>
                <li className="flex items-start">
                  <span
                    className={`mr-2 ${
                      userDetails?.is_finalized_excel?.some(
                        (item) =>
                          item.status === "Submitted" ||
                          item.status === "Accepted" ||
                          item.status === "Finalized"
                      )
                        ? "text-green-500"
                        : "text-gray-500"
                    }`}
                  >
                    {userDetails?.is_finalized_excel?.some(
                      (item) =>
                        item.status === "Submitted" ||
                        item.status === "Accepted" ||
                        item.status === "Finalized"
                    )
                      ? "✓"
                      : "✗"}
                  </span>
                  <span>Applications Submitted</span>
                </li>
                <li className="flex items-start">
                  <span
                    className={`mr-2 ${
                      userDetails?.is_finalized_excel?.some(
                        (item) =>
                          item.status === "Accepted" ||
                          item.status === "Finalized"
                      )
                        ? "text-green-500"
                        : "text-gray-500"
                    }`}
                  >
                    {userDetails?.is_finalized_excel?.some(
                      (item) =>
                        item.status === "Accepted" ||
                        item.status === "Finalized"
                    )
                      ? "✓"
                      : "✗"}
                  </span>
                  <span>Decision Received</span>
                </li>
                <li className="flex items-start">
                  <span
                    className={`mr-2 ${
                      userDetails?.is_finalized_excel?.some(
                        (item) => item.status === "Finalized"
                      )
                        ? "text-green-500"
                        : "text-gray-500"
                    }`}
                  >
                    {userDetails?.is_finalized_excel?.some(
                      (item) => item.status === "Finalized"
                    )
                      ? "✓"
                      : "✗"}
                  </span>
                  <span>University Finalized</span>
                </li>
              </ul>
            </div>

            {/* Visa Process Section */}
            <div className="bg-white p-4 rounded-lg shadow">
              <div className="flex items-center mb-3">
                <div className="bg-green-500 p-3 rounded-full mr-3 flex-shrink-0">
                  <IconPlaneTilt stroke={0} fill="white" size={24} />
                </div>
                <h3 className="text-lg font-medium">Visa Process</h3>
              </div>

              {/* Progress bar */}
              <div className="w-full h-2 bg-gray-200 rounded-full mb-4">
                <div
                  className="h-2 bg-indigo-500 rounded-full"
                  style={{
                    width: `${userDetails?.visa_process_completed ? 100 : 0}%`,
                  }}
                ></div>
              </div>

              {/* Items */}
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span
                    className={`mr-2 ${
                      userDetails?.visa_process_completed
                        ? "text-green-500"
                        : "text-gray-500"
                    }`}
                  >
                    {userDetails?.visa_process_completed ? "✓" : "✗"}
                  </span>
                  <span>Visa Process Completed</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusComponent;
